import BaseEndpoint from "../endpoints/baseEndpoint";

export default async function getPotentialTest(version) {
    try {
        let token = "";
        try {
            const raw = JSON.parse(localStorage.getItem('authUser'));
            token = raw?.token || raw?.user?.token || "";
        } catch (e) {}
        const tokenQuery = token ? `?token=${encodeURIComponent(token)}` : "";

        const sessionData = await BaseEndpoint.instance().get(
            `/exam/${version}/instruction${tokenQuery}`
        );
        const soalData = await BaseEndpoint.instance().get(`/exam/${version}${tokenQuery}`);

        let sessions = [];
        sessionData.data.forEach((item, index) => {
            let timer = item.timer;
            while (typeof timer === "string") {
                try { timer = JSON.parse(timer); } catch (e) { break; }
            }
            if (!timer || typeof timer !== "object") timer = {};

            const instruksiSec = Number(timer.instruksi ?? timer.instruction ?? 60);
            const ujianSec = Number(timer.ujian ?? timer.exam ?? 60);
            const inkolomSec = Number(timer.inkolom ?? timer.ujian ?? timer.exam ?? 60);
            const changekolomSec = Number(timer.changekolom ?? timer.break ?? 5);

            sessions.push({
                name: item.mapel,
                type: "instruction",
                content: item.instruksi,
                duration: (instruksiSec > 0 ? instruksiSec : 60) * 1000,
            });

            if (item.mapel === "Potensi Kerja") {
                console.log('🔧 Building PT Potensi Kerja sessions...');
                console.log('Raw soal data:', soalData.data[index]);

                // Group questions by column
                let soal = [];
                const rawKolomData = Array.isArray(soalData.data[index]) ? soalData.data[index] : [];
                rawKolomData.forEach((itm, idx) => {
                    let currentColumn = parseInt(itm.kolom) - 1;
                    if (isNaN(currentColumn) || currentColumn < 0) currentColumn = 0;

                    if (soal[currentColumn] === undefined) {
                        soal[currentColumn] = [];
                    }

                    soal[currentColumn].push(itm);
                });

                console.log('📊 Grouped by columns:', soal);
                console.log('Number of columns:', soal.length);
                console.log('Questions per column:', soal.map(col => col.length));

                // Add exam sessions with breaks between columns (not before first column)
                let currentColumn = 0;
                soal.forEach((itm, idx) => {
                    // Add break BETWEEN columns (not before first column)
                    if (idx !== 0) {
                        console.log(`⏸️ Adding break before column ${idx + 1}`);
                        sessions.push({
                            name: item.mapel,
                            type: "break",
                            duration: (changekolomSec > 0 ? changekolomSec : 5) * 1000,
                        });

                        currentColumn = idx;
                    }

                    console.log(`📝 Adding exam session for column ${idx + 1} with ${itm.length} questions`);
                    sessions.push({
                        name: item.mapel,
                        type: "exam",
                        content: itm,
                        duration: (inkolomSec > 0 ? inkolomSec : 60) * 1000,
                    });
                });
            } else {
                sessions.push({
                    name: item.mapel,
                    type: "exam",
                    content: soalData.data[index] || [],
                    duration: (ujianSec > 0 ? ujianSec : 60) * 1000,
                });
            }
        });

        // get data after index 5 then reindex
        // let afterIndex = sessions.splice(6);
        // return afterIndex;

        console.log('✅ PT Sessions built successfully:');
        sessions.forEach((s, i) => {
            console.log(`  [${i}] ${s.name} - ${s.type} - ${s.content?.length || 0} items - ${s.duration}ms`);
        });

        return sessions;
    } catch (error) {
        console.error('❌ Error loading Potential Test session:', error);
        return [];
    }
}
